import './polyfills/customEvent'; // Necessary for bricklayer.js dependency
import './polyfills/scopedQuerySelectorShim'; // Necessary for bricklayer.js dependency

import init from './init';
import headerSection from './sections/header';
import modalSection from './sections/modal';

init();
headerSection();
modalSection();



// WEBPACK FOOTER //
// ./source/scripts/main.js